import React, {Component} from 'react';
import {connect} from "react-redux";
import {ExternalLink} from "../helpers/EasyLinks";
import './SponsorsPanel.css'

class SponsorsPanel extends Component {
    render() {
        const frontpageSponsors = this.props.sponsors.filter(group => group.frontpage);
        return (
            <div className="sponsors-panel">
                {frontpageSponsors.map(group => {
                    const groupName = group.name + (group.sponsors.length > 1 ? 's' : '');
                    return <div key={group.key} className={"sponsors" + (this.props.simple ? '-bw':'')}>
                        <h2>{groupName}</h2>
                        <div className="sponsor-group">
                        {group.sponsors.map((sponsor, index) => (
                            <div key={group.key + index} className={group.key + "-sponsor sponsor"}>
                                <ExternalLink link={sponsor.url} key={sponsor.key}>
                                    <figure><img className={group.key + '-img'} src={sponsor.imageUrl} alt={sponsor.company}/></figure>
                                </ExternalLink>
                            </div>
                        ))}
                        </div>
                    </div>
                })}
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        sponsors: state.sponsors,
        hasErred: state.sponsorsHasErred
    };
};

export const FeaturedSponsors = connect(mapStateToProps)(SponsorsPanel);



// WEBPACK FOOTER //
// ./src/components/sponsors/SponsorsPanel.js